import { useQuery } from "react-query";
import { JobDetailResponse } from "../../../../models/Job";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import ApiClient from "../../../apiClient";

export const fetchJobKey = "job-key";

export async function fetchJob(JobID: string): Promise<JobDetailResponse> {
  const res = await ApiClient.get(`/JobDetail?JOB_ID=${JobID}`);
  return res.data[0];
}

export default function useFetchJob(JobID: string) {
  return useQuery([fetchJobKey, JobID], queryWrapper(fetchJob));
}
